<template>
  <el-col ref="chartContainer">
    <w-timeline-chart :active="active" @clickChart="onClickChart" />
    <div v-for="chart in charts" :key="chart.id">
      <w-performance-analysis-multi-obj-chart
        v-if="chart.chartType === performanceAnalysisChartType['MUTIL_OBJ']"
        :active="active"
        :chart-data="chart"
        :visible="chart.visible"
        :obj-list="objList"
        @clickChart="onClickChart"
        @show-sub-chart-button-click="onShowSubChartButtonClick"
      />
      <w-performance-analysis-multi-rsc-key-chart
        v-else-if="chart.chartType === performanceAnalysisChartType['MUTIL_RSC_KEY']"
        :active="active"
        :chart-data="chart"
        :visible="chart.visible"
        :obj-list="objList"
        @clickChart="onClickChart"
        @show-sub-chart-button-click="onShowSubChartButtonClick"
      />
      <w-performance-analysis-chart
        v-else
        active="active"
        :chart-data="chart"
        :visible="chart.visible"
        @clickChart="onClickChart"
        @show-sub-chart-button-click="onShowSubChartButtonClick" />
    </div>
  </el-col>
</template>

<script>
import { mapGetters } from 'vuex';
import { isNil, isArray, isEmpty, clone } from 'lodash';
import { PerformanceAnalysisChartType } from '@/constants/performance';
import { getPerfChartTypeParams } from '@/utils/performance';
// import AnalysisMixin from '@/mixins/performance/analysis';
import perfCommonApi from '@/api/performance/common';
import WTimelineChart from '@/views/performance/node/analysis/components/TimelineChart';
import WPerformanceAnalysisChart from './PerformanceAnalysisChart';
import WPerformanceAnalysisMultiObjChart from './PerformanceAnalysisMultiObjChart';
import WPerformanceAnalysisMultiRscKeyChart from './PerformanceAnalysisMultiRscKeyChart';

export default {
  name: 'WPerformanceAnalysisChartView',
  components: {
    WTimelineChart,
    WPerformanceAnalysisChart,
    WPerformanceAnalysisMultiObjChart,
    WPerformanceAnalysisMultiRscKeyChart,
  },
  props: {
    active: {
      type: Boolean,
    },
    perfChartTypeData: {
      type: Object,
    },
    preventCheckChartTypeByMgr: {
      type: Boolean,
      default: false,
    },
    chartDatas: {
      type: Array,
    },
    objList: {
      type: Array,
    },
  },
  data() {
    return {
      performanceAnalysisChartType: PerformanceAnalysisChartType,
      charts: [],
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectedNode: {
      immediate: true,
      handler(node) {
        if (!this.active || isEmpty(node)) {
          return;
        }
        this.$store.dispatch('setPlotLineDatetime', null);
        if (!this.preventCheckChartTypeByMgr) {
          this.loadPerfChartTypeByMgr();
        }
      },
    },
    active: {
      handler(active) {
        if (!this.preventCheckChartTypeByMgr && active) {
          this.loadPerfChartTypeByMgr();
        }
      },
    },
    chartDatas: {
      immediate: true,
      handler(value) {
        if (!this.preventCheckChartTypeByMgr || !this.active || isEmpty(value)) {
          return;
        }
        this.setCharts(value);
      },
    },
  },
  methods: {
    /**
     * 사용자 별 분석 그래프 설정 데이터를 가져와서 표현할 자원의 컴포넌트를 설정한다.
     * @author jda
     * @return {[type]} [description]
     */
    loadPerfChartTypeByMgr() {
      perfCommonApi.getPerfChartTypeByMgr(getPerfChartTypeParams(this.selectedNode.obj)).then((response) => {
        if (response.data.success) {
          const result = response.data.data;
          const filteredPerfChartTypeData = [];
          result.forEach((record) => {
            if (!isEmpty(this.perfChartTypeData[record.chartTypeId])) {
              filteredPerfChartTypeData.push(this.perfChartTypeData[record.chartTypeId]);
            }
          });
          this.setCharts(filteredPerfChartTypeData);
        }
      });
    },
    setCharts(perfChartTypeDatas) {
      const charts = [];
      perfChartTypeDatas.forEach((data) => {
        const chart = clone(data);
        chart.visible = true;
        charts.push(chart);
      });
      this.charts = charts;
    },
    /**
     * 차트 클릭시 보여지는 모든 자원 차트에 Flot Line을 표현한다.
     * @param  {[type]} chart [description]
     * @param  {[type]} e     [description]
     * @return {[type]}       [description]
     * @author jda
     */
    onClickChart(chart, e) {
      if (isNil(chart.series[0])) {
        return;
      }
      const point = chart.series[0].searchPoint(e, true);
      this.$refs.chartContainer.$children.forEach((component) => {
        const refs = component.$refs;
        const chartKeys = Object.keys(refs).filter((key) => key.toLowerCase().indexOf('chart'));
        if (point) {
          chartKeys.forEach((key) => {
            let plotLineChart = refs[key];
            if (isArray(refs[key])) {
              plotLineChart = plotLineChart[0];
            }
            if (!isNil(plotLineChart) && plotLineChart.visible) {
              plotLineChart.setPlotLine(point.x);
              plotLineChart.setCustomTooltip('plotLine');
            }
          });
        }
      });
    },
    onShowSubChartButtonClick(id, showSubChart) {
      this.charts.forEach((chart) => {
        if (chart.id !== id) {
          chart.visible = !showSubChart;
        }
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/components/PerformanceAnalysisChartView/index.vue